export const css = {
    root: 'P58Zp-nL',
    ' _key': 'landing-page/general'
};
export default css;
